import { useDeliveryMethods } from "../../customHooks/useDeliveryMethods";

const ShowDeliveryMethod = ({ deliveryMethodID }) => {
  const { getDeliveryMethodName } = useDeliveryMethods();
  return getDeliveryMethodName(deliveryMethodID) || "Not Found";
}

export default ShowDeliveryMethod;